<template>
  <v-container class="px-0 ma-0 py-3">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card rounded="lg" class="pa-6" elevation="3">
          <v-row no-gutters class="card-header">
            <v-col cols="12">
              <p
                style="
                  color: #1a1a1a;
                  font-size: 14px;
                  font-weight: 600;
                  margin-bottom: 20px;
                "
              >
                Updates
              </p>
            </v-col>
          </v-row>
          <div class="new-comment comment-input mb-3">
            <div class="card position-relative">
              <!-- Quill Editor بدل textarea -->
              <QuillEditor
                ref="quill"
                v-model:content="editorHtml"
                contentType="html"
                class="comment-quill"
                theme="snow"
                :toolbar="toolbarOptions"
                @text-change="handleQuillInput"
              />

              <!-- Image Preview -->
              <div v-if="allMediaFils.length" class="image-preview-overlay">
                <div
                  v-for="(media, index) in allMediaFils"
                  :key="index"
                  class="image-preview-container"
                >
                  <img :src="media.preview" alt="Preview" />
                  <button
                    class="remove-image"
                    @click="removeImage(index, allMediaFils)"
                  >
                    ×
                  </button>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="textarea-actions">
                <div class="btn-groups">
                  <div class="emoji-container" ref="emojiContainer">
                    <button
                      class="btn-post d-flex align-center"
                      @click="toggleEmojiPicker"
                      ref="emojiButton"
                    >
                      <!-- SVG Emoji -->
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.8284 11.8284C11.457 12.1999 11.0161 12.4945 10.5307 12.6955C10.0454 12.8966 9.52529 13 9 13C8.47471 13 7.95456 12.8966 7.46926 12.6955C6.98395 12.4945 6.54299 12.1999 6.17156 11.8284M17 9C17 10.0506 16.7931 11.0909 16.391 12.0615C15.989 13.0321 15.3997 13.914 14.6569 14.6569C13.914 15.3997 13.0321 15.989 12.0615 16.391C11.0909 16.7931 10.0506 17 9 17C7.94943 17 6.90914 16.7931 5.93853 16.391C4.96793 15.989 4.08601 15.3997 3.34315 14.6569C2.60028 13.914 2.011 13.0321 1.60896 12.0615C1.20693 11.0909 1 10.0506 1 9C1 6.87827 1.84285 4.84344 3.34315 3.34315C4.84344 1.84285 6.87827 1 9 1C11.1217 1 13.1566 1.84285 14.6569 3.34315C16.1571 4.84344 17 6.87827 17 9ZM7 7C7 7.368 6.85067 7.66667 6.66667 7.66667C6.48267 7.66667 6.33333 7.368 6.33333 7C6.33333 6.632 6.48267 6.33333 6.66667 6.33333C6.85067 6.33333 7 6.632 7 7ZM6.66667 7H6.67378V7.01333H6.66667V7ZM11.6667 7C11.6667 7.368 11.5173 7.66667 11.3333 7.66667C11.1493 7.66667 11 7.368 11 7C11 6.632 11.1493 6.33333 11.3333 6.33333C11.5173 6.33333 11.6667 6.632 11.6667 7ZM11.3333 7H11.3404V7.01333H11.3333V7Z"
                          stroke="#999999"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <!-- Emoji Picker -->
                    <div v-if="showEmojiPicker" class="emoji-picker-wrapper">
                      <emoji-picker @emoji-click="onEmojiClick"></emoji-picker>
                    </div>
                  </div>

                  <div class="img-button d-flex align-center justify-center">
                    <Image
                      @fileSelected="
                        (res) => handleFileSelected(res, 'allPostContent')
                      "
                    />
                  </div>

                  <div class="mention-container" ref="mentionsContainer">
                    <button
                      class="mention-btn"
                      @click="toggleUsersList"
                      ref="mentionButton"
                    >
                      <!-- SVG mention -->
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9262 5.49463C11.8647 4.54847 11.5778 3.63075 11.0894 2.81808C10.5553 1.95865 9.81143 1.24912 8.92777 0.756158C8.0441 0.263199 7.04961 0.00299806 6.03775 5.09009e-06H6.00698C4.82674 -0.00153203 3.67225 0.345102 2.68806 0.996516C1.70386 1.64793 0.933669 2.57518 0.473903 3.6622C0.0141383 4.74921 -0.114777 5.9477 0.103296 7.10763C0.321369 8.26755 0.87674 9.33739 1.69989 10.1832C2.67826 11.188 3.97746 11.8188 5.37217 11.966C6.76689 12.1132 8.16915 11.7677 9.33575 10.9893C9.43006 10.9211 9.49514 10.8198 9.51795 10.7057C9.54077 10.5916 9.51965 10.4731 9.45881 10.374C9.39254 10.2774 9.29163 10.2102 9.17705 10.1861C9.06246 10.162 8.94302 10.183 8.84352 10.2447C8.06875 10.7624 7.16644 11.0569 6.23545 11.0958C5.30445 11.1348 4.3807 10.9167 3.56541 10.4655C2.75012 10.0144 2.07474 9.34747 1.61327 8.53796C1.15181 7.72844 0.922071 6.80753 0.949224 5.87611C1.01302 4.56474 1.57291 3.32665 2.51546 2.41267C3.458 1.49868 4.71273 0.977146 6.02544 0.953719C7.2949 0.937521 8.52152 1.41243 9.44911 2.27924C10.3767 3.14606 10.9335 4.33774 11.0032 5.60538L11.0771 6.44834C11.0771 7.30361 10.5848 8.02966 9.99412 8.02966C9.40344 8.02966 8.9235 7.30361 8.9235 6.44834V3.53798C8.9235 3.41559 8.87488 3.29821 8.78834 3.21166C8.7018 3.12512 8.58442 3.0765 8.46203 3.0765C8.33964 3.0765 8.22226 3.12512 8.13572 3.21166C8.04917 3.29821 8.00055 3.41559 8.00055 3.53798V3.87639C7.57111 3.46894 7.02805 3.2015 6.44326 3.10948C5.85848 3.01745 5.25953 3.10518 4.7257 3.36104C4.19187 3.61691 3.74832 4.02885 3.45376 4.54234C3.1592 5.05584 3.02751 5.64668 3.07613 6.23666C3.12475 6.82664 3.35138 7.38795 3.72603 7.8463C4.10068 8.30465 4.60569 8.63842 5.1742 8.80344C5.74272 8.96846 6.34794 8.95695 6.90978 8.77044C7.47161 8.58392 7.96356 8.23119 8.32051 7.75893C8.4649 8.09086 8.69935 8.37573 8.99732 8.58126C9.29529 8.78679 9.64486 8.90478 10.0064 8.92185C11.1078 8.92185 12 7.79585 12 6.37451L11.9262 5.49463ZM6.00698 7.9989C5.61148 7.9989 5.22485 7.88162 4.896 7.66188C4.56715 7.44215 4.31084 7.12984 4.15948 6.76443C4.00813 6.39903 3.96853 5.99696 4.04569 5.60905C4.12285 5.22114 4.3133 4.86482 4.59297 4.58516C4.87263 4.30549 5.22895 4.11503 5.61686 4.03787C6.00477 3.96071 6.40684 4.00032 6.77225 4.15167C7.13765 4.30302 7.44996 4.55933 7.66969 4.88819C7.88943 5.21704 8.00671 5.60367 8.00671 5.99917C8.00508 6.52903 7.79388 7.03673 7.41921 7.4114C7.04454 7.78607 6.53685 7.99727 6.00698 7.9989Z"
                          fill="#666666"
                        />
                      </svg>
                      Mention
                    </button>

                    <!-- Mentions List -->
                    <div v-if="showUsersList" class="mentions-dropdown">
                      <div
                        v-for="user in filteredUsers"
                        :key="user.id"
                        class="mention-item"
                        @click="selectUser(user)"
                      >
                        <img
                          style="width: 24px; height: 24px"
                          :src="user.image"
                          alt=""
                        />
                        {{ user.first_name }} {{ user.last_name }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="send-button">
                  <button @click="addUpdate()">Send</button>
                </div>
              </div>
            </div>
          </div>

          <UpdatesCompView
            :key="updatesKey"
            :item="item"
            :call="call"
            ref="updatesRef"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "emoji-picker-element";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import Image from "@/components/crm/leads/comments/newUpdates/Image.vue";
import apiClient from "@/core/buildRequest";
import UpdatesCompView from "@/components/crm/leads/SingleLeadCom/Updates.vue";

export default {
  name: "CommentInput",
  components: { Image, UpdatesCompView, QuillEditor },
  props: ["item"],
  data() {
    return {
      postContent: "", // النص العادي المستخرج من Quill (بدون تنسيقات)
      showEmojiPicker: false,
      showUsersList: false,
      mentionTriggerPos: -1,
      enterPostlink: false,
      newLinkName: "",
      newLinkHref: "",
      links: [],
      images: [],
      allMediaFils: [],
      users: [],
      mentions: [],
      updatesKey: 0,
      toolbarOptions: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
      editorHtml: "",
      postContent: "",
    };
  },

  computed: {
    filteredUsers() {
      if (this.mentionTriggerPos === -1) return this.users;
      const searchText = this.postContent
        .slice(this.mentionTriggerPos + 1)
        .toLowerCase();
      return this.users.filter((user) =>
        user.first_name.toLowerCase().includes(searchText)
      );
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("keyup", this.handleKeyup); // بدل @keyup على textarea
    this.getAllUsers();
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keyup", this.handleKeyup);
  },

  methods: {
    getEditor() {
      return this.$refs.quill ? this.$refs.quill.getEditor() : null;
    },

    handleClickOutside(event) {
      const emojiContainer = this.$refs.emojiContainer;
      const emojiButton = this.$refs.emojiButton;
      const mentionsContainer = this.$refs.mentionsContainer;
      const mentionButton = this.$refs.mentionButton;

      if (
        this.showEmojiPicker &&
        emojiContainer &&
        !emojiContainer.contains(event.target) &&
        !emojiButton.contains(event.target)
      ) {
        this.showEmojiPicker = false;
      }

      if (
        this.showUsersList &&
        mentionsContainer &&
        !mentionsContainer.contains(event.target) &&
        !mentionButton.contains(event.target)
      ) {
        this.showUsersList = false;
      }
    },

    // بدل handleInput الخاصة بالـ textarea
    handleQuillInput(delta, oldDelta, source) {
      if (source !== "user") return;

      const editor = this.getEditor();
      if (!editor) return;

      // نص عادي بدون آخر \n
      const text = editor.getText().replace(/\n$/, "");
      this.postContent = text;

      const range = editor.getSelection(true);
      if (!range) return;

      const cursorPosition = range.index;
      const textBeforeCursor = this.postContent.slice(0, cursorPosition);
      const lastChar = textBeforeCursor[textBeforeCursor.length - 1];

      if (lastChar === "@") {
        this.mentionTriggerPos = cursorPosition - 1;
        this.showUsersList = true;
      }

      this.updateMentionsPositions(cursorPosition);
    },

    updateMentionsPositions(cursorPosition) {
      this.mentions = this.mentions.map((mention) => {
        if (mention.position >= cursorPosition) {
          return {
            ...mention,
            position: mention.position + 1,
          };
        }
        return mention;
      });
    },

    handleKeyup(e) {
      if (e.key === "Escape") {
        this.showUsersList = false;
        this.showEmojiPicker = false;
      }
    },

    selectUser(user) {
      const editor = this.getEditor();
      if (!editor) return;

      const name = `${user.first_name} ${user.last_name}`;
      const mentionText = `@${name} `;

      const insertIndex =
        this.mentionTriggerPos >= 0
          ? this.mentionTriggerPos
          : editor.getLength() - 1;

      // احذف الـ "@" اللي اتكتبت
      if (this.mentionTriggerPos >= 0) {
        editor.deleteText(this.mentionTriggerPos, 1, "user");
      }

      editor.insertText(insertIndex, mentionText, "user");

      this.mentions.push({
        id: user.id,
        name,
        position: insertIndex,
      });

      const text = editor.getText().replace(/\n$/, "");
      this.postContent = text;

      this.showUsersList = false;
      this.mentionTriggerPos = -1;

      editor.setSelection(insertIndex + mentionText.length, 0);
    },

    toggleUsersList(event) {
      event.stopPropagation();
      const editor = this.getEditor();
      if (!editor) return;

      this.showUsersList = !this.showUsersList;
      this.showEmojiPicker = false;

      if (this.showUsersList) {
        const length = editor.getLength(); // فيه \n في الآخر
        const index = length - 1;
        editor.insertText(index, "@", "user");
        editor.setSelection(index + 1, 0);
        this.mentionTriggerPos = index;

        const text = editor.getText().replace(/\n$/, "");
        this.postContent = text;
      }
    },

    toggleEmojiPicker(event) {
      event.stopPropagation();
      this.showEmojiPicker = !this.showEmojiPicker;
      this.showUsersList = false;
    },

    onEmojiClick(event) {
      const emoji = event.detail.unicode;
      const editor = this.getEditor();
      if (!editor) return;

      const range = editor.getSelection(true) || {
        index: this.postContent.length,
      };

      editor.insertText(range.index, emoji, "user");
      editor.setSelection(range.index + emoji.length, 0);

      const text = editor.getText().replace(/\n$/, "");
      this.postContent = text;

      this.showEmojiPicker = false;
    },

    handleFileSelected(res, typeOfSocilaMedia) {
      switch (typeOfSocilaMedia) {
        case "allPostContent":
          this.allMediaFils.push(res[0]);
          break;
      }
    },

    addLink() {
      if (this.newLinkName && this.newLinkHref) {
        this.links.push({
          name: this.newLinkName,
          href: this.newLinkHref,
        });
        this.newLinkName = "";
        this.newLinkHref = "";
        this.enterPostlink = false;
      }
    },

    removeLink(index) {
      this.links.splice(index, 1);
    },

    removeImage(index, array) {
      array.splice(index, 1);
    },

    // إرسال الـ Update (نفس الفلو القديم تقريبًا)
    addUpdate() {
      const formData = new FormData();
      formData.append("content", this.editorHtml);
      const mediaFile = this.allMediaFils[0]?.file;
      if (
        mediaFile &&
        (mediaFile instanceof File || mediaFile instanceof Blob)
      ) {
        formData.append("attachment", mediaFile);
      } else if (mediaFile) {
        console.warn("Attachment is not a valid file or blob:", mediaFile);
      }

      this.mentions.forEach((item, index) => {
        formData.append(`mention[${index}]`, item.id);
      });

      apiClient
        .post(
          `/leads-managment/leads/create-update/${this.$route.params.id}`,
          formData
        )
        .then((res) => {
          this.activities = res.data.data;
          this.$emit("update:added");
          this.postContent = "";
          this.allMediaFils = [];
          this.mentions = [];
          this.links = [];
          this.updatesKey += 1;
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    },

    async getAllUsers() {
      await apiClient
        .get("/leads-managment/all-agents")
        .then((res) => {
          this.users = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.comment-input {
  width: 100%;
  margin: 0 auto;
}

.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 2px solid #1f666a;
  position: relative;
}

.comment-textarea {
  width: 100%;
  min-height: 30px;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  resize: none;
  outline: none;
  transition: border-color 0.2s;
  font-size: 14px;
}

.textarea-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.75rem;
  padding-right: 1rem;
  padding-bottom: 0.25rem;
}

.btn-groups {
  display: flex;
  gap: 0.5rem;
}

.btn-post,
.mention-btn {
  padding: 0.5rem;
  border: none;
  background: transparent;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.2s;
}

.btn-post:hover,
.mention-btn:hover {
  background-color: #f3f4f6;
}

.emoji-container,
.mention-container {
  position: relative;
}

.emoji-picker-wrapper {
  /* position: absolute; */
  top: 100%;
  left: 0;
  margin-top: 0.5rem;
  z-index: 1000;
}

emoji-picker {
  --num-columns: 8;
  width: 320px;
  height: 400px;
}

.mentions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  width: 200px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mention-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.mention-item:hover {
  background: #f5f5f5;
}

.image-preview-overlay {
  margin-top: 0.5rem;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.image-preview-container {
  position: relative;
}

.image-preview-container img {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}

.send-button button {
  background-color: #237276;
  color: white;
  width: 51px;
  height: 32px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.send-button button:hover {
  background-color: #1a5457;
}

.mention {
  color: #1f666a;
  font-weight: 500;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.comment-quill {
  min-height: 80px;
}

.comment-quill .ql-editor {
  min-height: 60px;
  font-size: 14px;
}
</style>
